var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2217 15.2686L16.6817 14.9786C16.0717 14.9086 15.4717 15.1186 15.0417 15.5486L13.2017 17.3886C10.3717 15.9486 8.05174 13.6386 6.61174 10.7986L8.46174 8.94855C8.89174 8.51855 9.10174 7.91855 9.03174 7.30855L8.74174 4.78855C8.62174 3.77855 7.77174 3.01855 6.75174 3.01855H5.02174C3.89174 3.01855 2.95174 3.95855 3.02174 5.08855C3.55174 13.6286 10.3817 20.4486 18.9117 20.9786C20.0417 21.0486 20.9817 20.1086 20.9817 18.9786V17.2486C20.9917 16.2386 20.2317 15.3886 19.2217 15.2686Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ac74389f8172768619b2c09e88723018.svg";
export { ForwardRef as ReactComponent };